<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.dataClassification}">
      Categorize this event as
      <input :value="dataClassification" name="dataClassification" class="form-control" @input="handleChange">
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      dataClassification: String,
      id: String
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.dataClassification) {
          this.errors.dataClassification = "Please enter a category.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
